<template>
	<div :class="theme">
		<div class="pages" :class="[activeIndex > 0 && theme != 'blue' && theme != 'yellow' ? 'pt' : '']" @mouseover="onHoverEnter" @mouseleave="onHoverLeave">
			<Header @showMenu="showMenu" v-if="activeIndex > 0"></Header>
			<transition name="fade">
				<div class="menu" v-show="isMenu">
					<Menu @toMenu="toMenu" @hideMenu="hideMenu"></Menu>
				</div>
			</transition>
			<div>
				<swiper :class="{ 'custom-class': true }" ref="insideSwiper" :options="insideSwiperOptions" @slideChange="slideChange">
					<swiper-slide></swiper-slide>
					<swiper-slide v-for="(item, index) in menuData" :key="item.key">
						<!-- 根据 item.key 动态选择组件 -->
						<component :is="item.key" :index="index"></component>
					</swiper-slide>
					<!--分页器。如果放置在swiper外面，需要自定义样式。-->
					<div v-show="activeIndex > 0" class="swiper-pagination" slot="pagination"></div>
				</swiper>
			</div>
			<div v-show="activeIndex > 0 && isShowNav" class="swiper-button-prev" slot="button-prev"></div>
			<div v-show="activeIndex > 0 && isShowNav && isShowNext" class="swiper-button-next" slot="button-next"></div>
			<Footer v-if="activeIndex > 0"></Footer>
		</div>
	</div>
</template>

<script>
import Header from '@/components/header.vue'
import Menu from '@/components/menu.vue'
import Footer from '@/components/footer.vue'
import Grow from '@/views/grow.vue'
import Operating from '@/views/operating.vue'
import Performance from '@/views/performance.vue'
import Custom1 from '@/views/custom1.vue'
import Custom2 from '@/views/custom2.vue'
import cStyle1 from '@/views/cStyle1.vue'
import cStyle2 from '@/views/cStyle2.vue'
import Profitability1 from '@/views/profitability1.vue'
import Profitability2 from '@/views/profitability2.vue'
import Regulatory from '@/views/capital.vue'
import Solvency from '@/views/solvency.vue'
import Cash from '@/views/cash'
import Shareholders from '@/views/shareholders'
import Profile from '@/views/profile'
import Chairman from '@/views/chairman'
import Announcement from '@/views/announcement'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.min.css'
import { mapState } from 'vuex'
export default {
	name: 'pages',
	components: {
		Swiper,
		SwiperSlide,
		Header,
		Menu,
		Footer,
		Grow,
		Operating,
		Performance,
		cStyle1,
		cStyle2,
		Profitability1,
		Profitability2,
    Regulatory,
		Solvency,
		Cash,
		Shareholders,
		Profile,
		Chairman,
		Announcement,
		Custom1,
		Custom2,
	},
	data() {
		return {
			menuData: [],
			isMenu: false, //是否显示菜单
			isShowNav: false, //是否显示左右箭头
			isShowNext: true, //是否显示右箭头
			activeIndex: 1, //当前页index
			isTouchCapable: false, // 检测设备是否支持触摸
			insideSwiperOptions: {
				// swiper配置
				pagination: {
					//分页器导航
					el: '.swiper-pagination', //分页器class
					// 设置点击可切换
					clickable: true,
				},
				initialSlide: 1, //初始化时slide的索引
				keyboard: true, // 设置开启键盘来控制Swiper切换
				bulletElement: 'li', //设定分页器指示器（小点）的HTML标签。
				// 设置前进后退按钮
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
					hidden: true, // 初始隐藏导航按钮
				},
				grabCursor: true, // 鼠标覆盖Swiper 时指针会变成手掌形状，拖动时指针会变成抓手形状
				setWrapperSize: true, // 添加等于slides相加的宽或高，在对flexbox布局的支持不是很好的浏览器中可能需要用到。
				roundLengths: true, //将slide的宽和高取整(四舍五入)，以防止某些分辨率的屏幕上文字或边界(border)模糊
			},
			slideList: [], //side数据
      pageSize: 0, //总页数
      isOne: true, // 是否为第一次进入页面
		}
	},
	computed: {
		...mapState(['theme', 'language', 'jsonData','isLongChart']),
	},
	watch: {
		language(newData, oldData) {
			if (newData == 'zh') {
				this.menuData = JSON.parse(this.jsonData.moduleData)
			} else {
				this.menuData = JSON.parse(this.jsonData.moduleDataEng)
			}
		},
	},
	mounted() {
		this.$refs.insideSwiper.$swiper
		this.touchCapable()
		if (this.language == 'zh') { // 根据语言获取相应数据
			this.menuData = JSON.parse(this.jsonData.moduleData)
		} else {
			this.menuData = JSON.parse(this.jsonData.moduleDataEng)
		}
    this.pageSize=this.menuData.length;
	},
	methods: {
		// 检测设备是否支持触摸
		touchCapable() {
			this.isTouchCapable = !(
				'ontouchstart' in window ||
				(window.DocumentTouch && document instanceof window.DocumentTouch) ||
				navigator.maxTouchPoints > 0 ||
				window.navigator.msMaxTouchPoints > 0
			)
			this.$refs.insideSwiper.$swiper.simulateTouch = this.isTouchCapable
		},
		// 鼠标移入事件
		onHoverEnter() {
			this.isShowNav = true
		},
		// 鼠标移出事件
		onHoverLeave() {
			this.isShowNav = false
		},
		// Slide切换到另一个Slide时执行
		slideChange() {
      let realIndex = this.$refs.insideSwiper.$swiper.activeIndex
			this.activeIndex = realIndex
      // if (this.isOne){ // 是否为第一次进入页面
      //   if (realIndex === 2){ // 第一次进触发两次翻页的话就就跳转到第一页
      //     this.$refs.insideSwiper.$swiper.slideTo(1, 500);
      //     this.isOne=false; // 将标记改为false，不刷新页面，就不会再进入此方法
      //   }
      // }

      // 当是最后一页时隐藏next箭头
      if (realIndex === this.pageSize) {
        this.isShowNext = false;
      } else {
        this.isShowNext = true;
      }

			// 当前index为0时，调用外层swiper方法，跳到首页
			if (this.activeIndex === 0) {
				// 修改当前swiper的index为1
				this.activeIndex = 1
				this.$refs.insideSwiper.$swiper.activeIndex = 1
				this.$refs.insideSwiper.$swiper.update()
				this.$emit('goToHomeSlide')
			}
			this.$store.commit('setMenuActiveIndex', this.activeIndex - 1)

		},
		// 跳转到对应index页面
		goToSlide(index) {
			this.$refs.insideSwiper.$swiper.allowSlidePrev = true
			this.$refs.insideSwiper.$swiper.allowSlideNext = true
			this.$refs.insideSwiper.$swiper.update()
			this.$refs.insideSwiper.$swiper.slideTo(index, 500) // 第二个参数是过渡时间（毫秒）
		},
		// 显示菜单
		showMenu() {
      if (this.isLongChart) {
        return false;
      }
      this.isMenu = true
    },
		// 隐藏菜单
		hideMenu() {
			this.isMenu = false
		},
		// 点击菜单执行
		toMenu(index) {
			this.isMenu = false
			if (index < 0) {
				// 点击首页时，index为-1，对应菜单里的下标0
				this.$store.commit('setMenuActiveIndex', 0)
				// 修改当前swiper的index为1
				this.activeIndex = 1
				this.$refs.insideSwiper.$swiper.activeIndex = 1
				this.$refs.insideSwiper.$swiper.update()
				this.$emit('goToHomeSlide')
			} else {
				this.$store.commit('setMenuActiveIndex', index)
				this.goToSlide(index + 1)
			}
		},
	},
}
</script>

<style lang="scss" scoped>
html,
body {
	overscroll-behavior: none;
}
.pages {
	height: 720px;
	position: relative;
	background-image: var(--nyBgImg);
	background-repeat: no-repeat;
	background-size: 100% 100%;
}

.pt {
	padding: 0 50px;
}

::v-deep .swiper-pagination-bullet {
	opacity: 1;
	width: 15px;
	height: 2px;
	border-radius: 2px;
	background: var(--bulletBgColor);
}
::v-deep .swiper-pagination-bullet-active {
	background: var(--baseColor);
}

.swiper-button-next,
.swiper-button-prev {
	color: #dddddd;
}
.menu {
	position: absolute;
	top: 0;
	left: 0;
	z-index: 999;
}
/* 过渡效果的 CSS 定义 */
.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
	opacity: 0;
}

.red {
  ::v-deep .swiper-pagination-bullet {
    opacity: 1;
    width: 9px;
    height: 9px;
    border-radius: 100%;
    border: 1px solid #F5CFCF;
    background: none;
  }
  ::v-deep .swiper-pagination-bullet-active {
    background: #D32F2E;
  }
}
.purple{
  ::v-deep .swiper-pagination-bullet {
    opacity: 1;
    width: 9px;
    height: 9px;
    border-radius: 100%;
    border: 1px solid #EBE4FA;
    background: none;
  }
  ::v-deep .swiper-pagination-bullet-active {
    background: #B4A3D7;
  }
}

.blue {
	.pages {
		background: #f4f7fd;
	}

	::v-deep .swiper-pagination-bullet {
		opacity: 1;
		width: 9px;
		height: 9px;
		border-radius: 100%;
		border: 1px solid rgba(94, 187, 245, 0.48);
		background: none;
	}
	::v-deep .swiper-pagination-bullet-active {
		background: #5dbbf5;
	}
}

.yellow {
	.pages {
		background: #151517;
	}

	::v-deep .swiper-pagination-bullet {
		opacity: 1;
		width: 9px;
		height: 9px;
		border-radius: 100%;
		border: 1px solid #151517;
		background: none;
	}
	::v-deep .swiper-pagination-bullet-active {
		background: #151517;
	}
}
</style>
